import { Component, OnInit } from '@angular/core';
import { LicenseData, SubsciptionData } from '../models/LicenseData';
import { LicenseService } from '../shared/licens.service';
import { ApiService } from '../shared/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Common } from '../shared/common';

@Component({
  selector: 'app-suspended-account',
  templateUrl: 'suspended-account.component.html',
  styleUrls: ['./suspended-account.component.less', '../shared/common.less'],
})

export class SuspendedAccountComponent implements OnInit {
  allSuspendedVoters: Array<SuspendedVoter> = [];
  get suspended() {
    return this.allSuspendedVoters;
  }
  filteredVoters: Array<SuspendedVoter> = [];
  pollId: string | null = null;
  selectedAccount: any = null;

  accountName: string = "";
  maxVoters: number = 5;
  hasHotline: boolean = false;
  shouldBuyCredits: boolean = false;
  language: string = 'fr';
  hotlinePopup: boolean = false

  constructor(
    public licenseService: LicenseService,
    private router: Router,
    private apiService: ApiService,
    private common: Common,
    public route: ActivatedRoute,


  ) {
  }

  onSearch(value: string) {
    const query = value.trim().toLowerCase();
    if (!query) {
      this.filteredVoters = [...this.suspended];
    } else {
      this.filteredVoters = this.suspended.filter(v =>
        v.firstName?.toLowerCase().includes(query) ||
        v.lastName?.toLowerCase().includes(query)
      );
    }
  }

  changeSubscription() {
    // this.shoulDisplayChangePopup = true;
    // this.smsAdditionalOption = true;
  }

  navigateArrow() {
    this.router.navigate(['/poll-ongoing/' + this.pollId]);
  }

  downloadGuide() {
    switch (this.language) {
      case 'fr': { window.open('https://medium.com/fr-guides-v8te', '_blank'); return; }
      case 'es': { window.open('https://medium.com/es-gu%C3%ADas-v8te', '_blank'); return; }
      default: { window.open('https://medium.com/en-v8te-guides', '_blank'); return; }
    }
  }

  downloadDocuments() {
    window.open('https://drive.google.com/drive/folders/1sP4ShTvOKcAU0fkFeNoibJCLao-pZfQC?usp=sharing', '_blank');
  }

  setSelectedVoter($event: any) {
    this.selectedAccount = $event;
  }

  contactMail() {
    const mailText = 'mailto:support_client@v8te.com';
    window.open(mailText);
  }

  initData() {
    this.licenseService.license.subscribe((res: LicenseData) => {
      if (res != null) {
        this.maxVoters = res.votes;
        this.hasHotline = res.hasHotline;
      }
    });
    this.licenseService.refreshLicense();
  }


  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.pollId = params.get('id');
      this.apiService.getSuspendedVoters(this.pollId).subscribe((res: Array<SuspendedVoter>) => {
        this.allSuspendedVoters = res;
        this.filteredVoters = [...this.suspended];
      });
    });
    const userLang = navigator.language;
    this.language = userLang.substring(0, 2);
  }
}

export class SuspendedVoter {
  public firstName: string;
  public lastName: string;
  public email: string;
  public attempts: number;
  public lockDate: Date;
}
